var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoMain"},[_c('video',{attrs:{"id":"vid","playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("../../assets/video/index.mp4"),"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }